// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iObS","content":"styles_content__3DsdW"};